import Fetch from '../../utils/fetch';
import { settings } from '../../settings';
import { HubSortInstruction } from '../../types/orderTypes';

export async function fetchHubSortScan(
  orderId: string,
  parcelId?: string,
  preSort?: boolean
): Promise<HubSortInstruction> {
  try {
    const response = await Fetch.put({
      url: `${settings.newApiUrl}/order/${orderId}/sort-scan`,
      body: {
        parcelId,
        preSort,
      },
    });
    if (response.ok) {
      return await response.json();
    }
  } catch (e) {
    console.warn(`Error fetching sort instruction for order ${orderId}`);
  }
  return undefined;
}
